import React, { useState } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';

import i18n from '@i18n';
import Dialog, { DialogActions, DialogBody, DialogButton, DialogTitle } from '@/ui/dialogs/Dialog';
import PopupNg from '@/ui/PopupNg';
import { ticketStornoClose, ticketStornoSubmit } from '@/mytickets/storno/handlers';

function StornoDialog() {
    const [gridChallenge, setGridChallenge] = useState('');
    const derefSub = useReframe();
    const state = derefSub(['ticketus/storno/state']);
    const gridPosition = derefSub(['ticketus/storno/gridPosition']);

    const close = PopupNg.dispatcher.close;
    function onClose() {
        dispatch(ticketStornoClose);
    }
    function onChange(e) {
        const gridCode = e.target.value;
        const gridCodeNormalize = gridCode.trim().slice(0, 3);
        setGridChallenge(gridCodeNormalize);
    }
    function handleConfirm() {
        dispatch(ticketStornoSubmit(gridChallenge));
        close();
    }
    if (state === 'opening') {
        return (
            <Dialog onClose={onClose}>
                <DialogTitle>
                    <h2>{i18n('jsp.stornoTiketu.title')}</h2>
                </DialogTitle>
                <DialogBody>
                    <div className="ajax-preloader" />
                </DialogBody>
            </Dialog>
        );
    }
    return (
        <Dialog onClose={onClose}>
            <DialogTitle>
                <h2>{i18n('jsp.stornoTiketu.title')}</h2>
            </DialogTitle>
            <DialogBody>
                {gridPosition ? (
                    <div className="nike-form">
                        <label className="nike-input">
                            <div className="nike-input-label">
                                {i18n('jsp.stornoTiketu.gridChallenge', '')}
                                <b>{gridPosition}</b>
                            </div>
                            <input type="text" value={gridChallenge} onChange={onChange} />
                        </label>
                    </div>
                ) : (
                    <p>{i18n('jsp.stornoTiketu.rly')}</p>
                )}
            </DialogBody>
            <DialogActions>
                <DialogButton className="light" onClick={close}>
                    {i18n('commons.button.zrusit')}
                </DialogButton>
                <DialogButton onClick={handleConfirm}>{i18n('commons.button.potvrdit')}</DialogButton>
            </DialogActions>
        </Dialog>
    );
}

export default StornoDialog;
